module.exports = __webpack_public_path__ + "assets/img/badca5f7329028038325d3141ec27086.png";